import { render } from "./BotHelperView.vue?vue&type=template&id=deb0ee2c"
import script from "./BotHelperView.vue?vue&type=script&lang=js"
export * from "./BotHelperView.vue?vue&type=script&lang=js"

import "./BotHelperView.vue?vue&type=style&index=0&id=deb0ee2c&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__